import React from 'react';
import { runtimeHooks } from './runtime-hooks.js';
import { Icon } from './icons.jsx';
import { setKB_ARTICLES, KB_ARTICLES, SUPPORT_AGENTS } from './support-data.jsx';

let TICKET_ARTICLES = {};
// Suporte — Base de Conhecimento (menu próprio)

const KB_STATUS_CFG_V2 = {
  publicado:       { label: 'Publicado',       cls: 'success' },
  rascunho:        { label: 'Rascunho',        cls: 'neutral' },
  arquivado:       { label: 'Arquivado',        cls: 'neutral' },
  precisa_revisao: { label: 'Precisa revisão', cls: 'warning' },
};

// ── Modal: Nova Categoria ──────────────────────────────────────────────────────
const NovaCategoriaModal = ({ open, onClose, onToast, onAdd }) => {
  const [form, setForm] = React.useState({ name:'', slug:'', description:'', icon:'bookOpen', order:1, parent:'', status:'ativo' });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  if (!open) return null;
  const slugify = (v) => v.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(3px)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ width:500,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden',animation:'scale-in 160ms cubic-bezier(0.2,0.8,0.2,1)' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--success-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="bookOpen" size={16} style={{ color:'var(--success)' }}/></div>
          <div><div style={{ fontWeight:600,fontSize:15 }}>Nova categoria</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>Organizar artigos por tema</div></div>
          <button className="icon-action" style={{ marginLeft:'auto' }} onClick={onClose}><Icon name="x" size={15}/></button>
        </div>
        <div style={{ padding:'20px 22px' }}>
          {[
            { label:'Nome da categoria',  key:'name',        type:'text',   ph:'Ex.: Configurações' },
            { label:'Slug',               key:'slug',        type:'text',   ph:'configuracoes'       },
            { label:'Descrição',          key:'description', type:'text',   ph:'Breve descrição…'    },
          ].map(f=>(
            <div key={f.key} style={{ marginBottom:14 }}>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>{f.label}</label>
              <input
                value={form[f.key]}
                onChange={e=>{ set(f.key,e.target.value); if(f.key==='name') set('slug',slugify(e.target.value)); }}
                style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }}
                placeholder={f.ph}
              />
            </div>
          ))}
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }}>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Ordem</label>
              <input type="number" value={form.order} onChange={e=>set('order',e.target.value)} style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }}/>
            </div>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Categoria pai</label>
              <select className="select" style={{ width:'100%',height:34 }} value={form.parent} onChange={e=>set('parent',e.target.value)}>
                <option value="">Nenhuma (raiz)</option>
                {['Configurações','Pagamento','Integrações','E-mail','Marketing'].map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Status</label>
            <div style={{ display:'flex',gap:8 }}>
              {['ativo','inativo'].map(s=>(
                <button key={s} onClick={()=>set('status',s)} style={{ padding:'6px 14px',borderRadius:'var(--radius)',border:`1.5px solid ${form.status===s?'var(--brand-navy)':'var(--border-strong)'}`,background:form.status===s?'color-mix(in srgb,var(--brand-navy) 6%,var(--bg-elevated))':'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontWeight:form.status===s?600:500,cursor:'pointer' }}>
                  {s==='ativo'?'Ativo':'Inativo'}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className="btn primary" onClick={()=>{
            if (!form.name) { onToast&&onToast('Informe o nome da categoria'); return; }
            const cat = { ...form, id: 'cat_' + Date.now(), articles: 0, views: 0, icon: form.icon || 'layers' };
            if (onAdd) onAdd(cat);
            onToast&&onToast(`Categoria "${form.name}" criada`);
            onClose();
          }}>
            <Icon name="check" size={13}/>Criar categoria
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Editor de Artigo ───────────────────────────────────────────────────────────
const KBArticleEditorV2 = ({ article, onBack, onToast, onSave, ticketContext, onNav }) => {
  const isNew = !article;
  // Se vier de um ticket, pré-preencher com contexto
  const ticketTitle   = ticketContext ? `Como resolver: ${ticketContext.subject}` : '';
  const ticketContent = ticketContext ? `# Como resolver: ${ticketContext.subject}\n\n> Artigo criado a partir do Ticket ${ticketContext.id} — ${ticketContext.tenant}\n\n## Problema\n\n${ticketContext.preview || ticketContext.subject}\n\n## Causa provável\n\n(Descreva a causa do problema aqui)\n\n## Passo a passo de solução\n\n1. Acesse o painel da loja\n2. (Complete com os passos)\n3. Salve as alterações\n\n## Observações internas\n\n> ⚠️ Remover antes de publicar: ticket de origem ${ticketContext.id}, tenant ${ticketContext.tenant}, prioridade ${ticketContext.priority || '—'}.\n` : '';

  const [form, setForm] = React.useState({
    title:      ticketContext ? ticketTitle : (article?.title       || ''),
    slug:       ticketContext ? ticketTitle.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'') : (article?.title?.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'') || ''),
    summary:    ticketContext ? (ticketContext.preview || '') : '',
    category:   ticketContext ? (ticketContext.category || '') : (article?.category   || ''),
    status:     article?.status     || 'rascunho',
    visibility: article?.visibility || 'Público',
    plan:       '',
    lang:       'pt-BR',
    author:     article?.author     || 'Ana Vargas',
    nextReview: '',
    content:    ticketContext ? ticketContent : (article ? `# ${article.title}\n\nEste artigo explica como resolver o problema de forma rápida e prática.\n\n## Pré-requisitos\n\n- Acesso ao painel administrativo da loja\n- Permissões de configuração ativas\n\n## Passo a passo\n\n1. Acesse **Configurações** no menu lateral\n2. Clique em **${article.category}**\n3. Preencha os campos conforme solicitado\n4. Clique em **Salvar**\n\n## Dúvidas frequentes\n\nSe encontrar alguma dificuldade, entre em contato com nosso suporte.\n` : ''),
    sourceTicket: ticketContext?.id || null,
    sourceTenant: ticketContext?.tenant || null,
  });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const [previewMode, setPreviewMode] = React.useState(false);

  const handleSave = (newStatus) => {
    const updated = { ...form, status: newStatus || form.status };
    set('status', updated.status);
    if (onSave) {
      onSave({
        ...(article || {}),
        id: article?.id || ('kb_' + Date.now()),
        title: form.title || 'Sem título',
        slug: form.slug || 'sem-titulo',
        category: form.category || 'Geral',
        status: updated.status,
        visibility: form.visibility,
        author: form.author,
        lastRevision: 'Agora',
        feedback: article?.feedback || { pos: 0, neg: 0 },
        views: article?.views || 0,
        ticketsAvoided: article?.ticketsAvoided || 0,
        summary: form.summary,
        sourceTicket: form.sourceTicket,
        sourceTenant: form.sourceTenant,
      });
    }
    onToast && onToast(updated.status === 'publicado' ? 'Artigo publicado' : updated.status === 'arquivado' ? 'Artigo arquivado' : 'Rascunho salvo');
    onBack && onBack();
  };

  const checklist = [
    { label:'Título claro e descritivo',  ok: form.title.length > 10        },
    { label:'Categoria definida',         ok: !!form.category               },
    { label:'Conteúdo com passos',        ok: form.content.includes('##')   },
    { label:'Revisão agendada',           ok: !!form.nextReview             },
    { label:'Artigos relacionados',       ok: false                         },
  ];

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:20,paddingBottom:16,borderBottom:'1px solid var(--border)',flexWrap:'wrap' }}>
        <button className="btn ghost sm" onClick={onBack} style={{ gap:4 }}>
          <Icon name="chevronLeft" size={14}/>Base de Conhecimento
        </button>
        <div style={{ width:1,height:20,background:'var(--border)' }}/>
        <span style={{ fontWeight:600,fontSize:14,flex:1 }}>{isNew ? (ticketContext ? `Novo artigo — Ticket ${ticketContext.id}` : 'Novo artigo') : (form.title || article?.title)}</span>
        <span style={{ fontSize:11,fontFamily:'JetBrains Mono,monospace',color:'var(--text-muted)',opacity:.7 }}>
          {isNew ? '/admin/support/knowledge-base/articles/new' : `/admin/support/knowledge-base/articles/${article?.id}`}
        </span>
        <span className={`badge ${KB_STATUS_CFG_V2[form.status]?.cls||'neutral'}`} style={{ fontSize:11 }}><span className="dot"/>{KB_STATUS_CFG_V2[form.status]?.label}</span>
        <div style={{ display:'flex',gap:6 }}>
          <button className="btn sm" onClick={()=>setPreviewMode(p=>!p)}><Icon name={previewMode?'edit':'maximize'} size={13}/>{previewMode?'Editar':'Prévia'}</button>
          <button className="btn sm" onClick={()=>handleSave('rascunho')}>Salvar rascunho</button>
          <button className="btn sm primary" onClick={()=>handleSave('publicado')}>
            <Icon name="globe" size={13}/>Publicar
          </button>
        </div>
      </div>

      {/* Layout 2 colunas */}
      <div style={{ display:'grid',gridTemplateColumns:'1fr 300px',gap:20,alignItems:'start' }}>

        {/* Editor */}
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'14px 18px' }}>
              <input
                value={form.title} onChange={e=>set('title',e.target.value)}
                style={{ width:'100%',border:'none',outline:'none',fontSize:22,fontWeight:600,color:'var(--text)',background:'transparent',fontFamily:'inherit',lineHeight:1.3 }}
                placeholder="Título do artigo…"
              />
              <div style={{ display:'flex',alignItems:'center',gap:6,marginTop:6 }}>
                <span style={{ fontSize:12,color:'var(--text-muted)' }}>slug:</span>
                <input value={form.slug} onChange={e=>set('slug',e.target.value)} style={{ flex:1,border:'none',outline:'none',fontSize:12,color:'var(--text-muted)',background:'transparent',fontFamily:'monospace' }} placeholder="slug-do-artigo"/>
              </div>
            </div>
            <div style={{ borderTop:'1px solid var(--border)',padding:'10px 14px',display:'flex',gap:8,background:'var(--bg-subtle)',flexWrap:'wrap' }}>
              {[{l:'B',fn:'**texto**'},{l:'I',fn:'*texto*'},{l:'H2',fn:'## Seção'},{l:'Lista',fn:'\n- item'},{l:'Código',fn:'`código`'},{l:'Link',fn:'[texto](url)'}].map(b=>(
                <button key={b.l} className="btn sm ghost" onClick={()=>set('content',form.content+b.fn)} style={{ fontWeight:600,minWidth:36 }}>{b.l}</button>
              ))}
            </div>
            {previewMode ? (
              <div style={{ padding:'20px 24px',minHeight:320 }}>
                <div style={{ fontSize:13,color:'var(--text-secondary)',lineHeight:1.8 }}>
                  {form.content.split('\n').map((line,i)=>{
                    if(line.startsWith('# ')) return <h1 key={i} style={{ fontSize:22,fontWeight:700,marginBottom:12,color:'var(--text)' }}>{line.slice(2)}</h1>;
                    if(line.startsWith('## ')) return <h2 key={i} style={{ fontSize:16,fontWeight:600,margin:'16px 0 8px',color:'var(--text)' }}>{line.slice(3)}</h2>;
                    if(line.startsWith('- ')) return <li key={i} style={{ marginLeft:16,marginBottom:4 }}>{line.slice(2)}</li>;
                    if(line.match(/^\d+\./)) return <li key={i} style={{ marginLeft:16,marginBottom:4,listStyle:'decimal' }}>{line.replace(/^\d+\.\s/,'')}</li>;
                    if(line==='') return <br key={i}/>;
                    return <p key={i} style={{ margin:'0 0 8px' }}>{line}</p>;
                  })}
                </div>
              </div>
            ) : (
              <textarea
                value={form.content} onChange={e=>set('content',e.target.value)}
                placeholder="Escreva o conteúdo em Markdown…"
                style={{ width:'100%',minHeight:360,padding:'18px',border:'none',outline:'none',resize:'vertical',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'var(--font-mono,monospace)',lineHeight:1.7 }}
              />
            )}
          </div>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14 }}>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Resumo / meta description</label>
              <textarea value={form.summary} onChange={e=>set('summary',e.target.value)} placeholder="Resumo para SEO e busca interna…" style={{ width:'100%',height:68,padding:'8px 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit',resize:'none' }}/>
            </div>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Tags</label>
              <input style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }} placeholder="dns, configuração, domínio…"/>
              <div style={{ fontSize:11,color:'var(--text-muted)',marginTop:4 }}>Separadas por vírgula</div>
            </div>
          </div>
        </div>

        {/* Sidebar direita */}
        <div style={{ display:'flex',flexDirection:'column',gap:12 }}>

          {/* Publicação */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Publicação</div>
            <div style={{ padding:'12px 14px',display:'flex',flexDirection:'column',gap:10 }}>
              {[
                { label:'Status', el: <select className="select" style={{ width:'100%',height:32,fontSize:12 }} value={form.status} onChange={e=>set('status',e.target.value)}><option value="rascunho">Rascunho</option><option value="publicado">Publicado</option><option value="arquivado">Arquivado</option><option value="precisa_revisao">Precisa revisão</option></select> },
                { label:'Visibilidade', el: <select className="select" style={{ width:'100%',height:32,fontSize:12 }} value={form.visibility} onChange={e=>set('visibility',e.target.value)}><option>Público</option><option>Logado</option><option>Plano específico</option><option>Tenant específico</option></select> },
                { label:'Idioma', el: <select className="select" style={{ width:'100%',height:32,fontSize:12 }} value={form.lang} onChange={e=>set('lang',e.target.value)}><option value="pt-BR">Português (BR)</option><option value="en">English</option></select> },
                { label:'Autor', el: <select className="select" style={{ width:'100%',height:32,fontSize:12 }} value={form.author} onChange={e=>set('author',e.target.value)}>{(SUPPORT_AGENTS||[]).map(a=><option key={a.id} value={a.name}>{a.name}</option>)}</select> },
                { label:'Próxima revisão', el: <input type="date" style={{ width:'100%',height:32,padding:'0 8px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:12,fontFamily:'inherit' }} value={form.nextReview} onChange={e=>set('nextReview',e.target.value)}/> },
              ].map(r=>(
                <div key={r.label}>
                  <label style={{ display:'block',fontSize:11,fontWeight:600,color:'var(--text-muted)',marginBottom:4 }}>{r.label}</label>
                  {r.el}
                </div>
              ))}
              <div>
                <label style={{ display:'block',fontSize:11,fontWeight:600,color:'var(--text-muted)',marginBottom:4 }}>Categoria</label>
                <select className="select" style={{ width:'100%',height:32,fontSize:12 }} value={form.category} onChange={e=>set('category',e.target.value)}>
                  <option value="">Selecionar…</option>
                  {['Configurações','Pagamento','Integrações','E-mail','Marketing','Billing','Frete','Catálogo'].map(c=><option key={c}>{c}</option>)}
                </select>
              </div>
            </div>
          </div>

          {/* Origem: ticket */}
          {ticketContext && (
            <div style={{ background:'color-mix(in srgb,var(--info) 8%,var(--bg-elevated))',border:'1px solid color-mix(in srgb,var(--info) 30%,var(--border))',borderRadius:10,overflow:'hidden' }}>
              <div style={{ padding:'10px 14px',borderBottom:'1px solid color-mix(in srgb,var(--info) 20%,var(--border))',fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--info)' }}>Origem</div>
              <div style={{ padding:'12px 14px',display:'flex',flexDirection:'column',gap:6 }}>
                <div style={{ fontSize:12,fontWeight:600,color:'var(--text)' }}>Ticket {ticketContext.id}</div>
                <div style={{ fontSize:11,color:'var(--text-secondary)',lineHeight:1.5 }}>{ticketContext.subject}</div>
                {ticketContext.tenant && <div style={{ fontSize:11,color:'var(--text-muted)' }}>Tenant: <strong>{ticketContext.tenant}</strong></div>}
                <button className="btn sm ghost" style={{ marginTop:4,justifyContent:'flex-start' }} onClick={()=>{
                  if (onNav && ticketContext?.id) onNav({ page: 'tickets', openTicketId: ticketContext.id });
                  else onToast && onToast(`Voltando ao ticket ${ticketContext.id}…`);
                }}>
                  <Icon name="chevronLeft" size={12}/>Voltar ao ticket
                </button>
              </div>
            </div>
          )}

          {/* Checklist de qualidade */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Checklist de qualidade</div>
            <div style={{ padding:'10px 14px',display:'flex',flexDirection:'column',gap:6 }}>
              {checklist.map(c=>(
                <div key={c.label} style={{ display:'flex',alignItems:'center',gap:8,fontSize:12 }}>
                  <div style={{ width:16,height:16,borderRadius:'50%',background:c.ok?'var(--success-bg)':'var(--bg-subtle)',border:`1.5px solid ${c.ok?'var(--success)':'var(--border-strong)'}`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                    {c.ok && <Icon name="check" size={9} style={{ color:'var(--success)' }}/>}
                  </div>
                  <span style={{ color:c.ok?'var(--text)':'var(--text-muted)' }}>{c.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Relacionamentos */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Relacionamentos</div>
            <div style={{ padding:'10px 14px',display:'flex',flexDirection:'column',gap:8 }}>
              {[
                { label:'Tickets relacionados',   icon:'messageCircle', count:3 },
                { label:'Macros relacionadas',     icon:'zap',           count:1 },
                { label:'Artigos relacionados',    icon:'bookOpen',      count:2 },
              ].map(r=>(
                <button key={r.label} className="btn sm ghost" style={{ justifyContent:'space-between' }} onClick={()=>onToast&&onToast(`${r.label}…`)}>
                  <span style={{ display:'flex',alignItems:'center',gap:6 }}><Icon name={r.icon} size={13}/>{r.label}</span>
                  <span className="badge neutral" style={{ fontSize:10 }}>{r.count}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Ações destrutivas */}
          <div style={{ display:'flex',flexDirection:'column',gap:6 }}>
            <button className="btn sm" style={{ justifyContent:'center' }} onClick={()=>handleSave('arquivado')}>
              <Icon name="fileText" size={13}/>Arquivar artigo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Tab: Artigos ───────────────────────────────────────────────────────────────
const KBArticlesTab = ({ onEditArticle, onNewArticle, onToast, articles: articlesProp }) => {
  const articles = articlesProp || KB_ARTICLES || [];
  const [search, setSearch]   = React.useState('');
  const [fStatus, setFStatus] = React.useState('');
  const [fCat, setFCat]       = React.useState('');

  const cats = [...new Set(articles.map(a=>a.category))].sort();
  const filtered = articles.filter(a => {
    if (search && !a.title.toLowerCase().includes(search.toLowerCase())) return false;
    if (fStatus && a.status !== fStatus) return false;
    if (fCat && a.category !== fCat)     return false;
    return true;
  });

  return (
    <div className="table-wrap">
      <div className="table-toolbar" style={{ gap:8,flexWrap:'wrap' }}>
        <div className="search" style={{ maxWidth:300 }}>
          <Icon name="search" size={14}/>
          <input placeholder="Buscar artigos…" value={search} onChange={e=>setSearch(e.target.value)}/>
        </div>
        <select className="select" value={fStatus} onChange={e=>setFStatus(e.target.value)}>
          <option value="">Status</option>
          <option value="publicado">Publicado</option>
          <option value="rascunho">Rascunho</option>
          <option value="precisa_revisao">Precisa revisão</option>
          <option value="arquivado">Arquivado</option>
        </select>
        <select className="select" value={fCat} onChange={e=>setFCat(e.target.value)}>
          <option value="">Categoria</option>
          {cats.map(c=><option key={c}>{c}</option>)}
        </select>
        <select className="select"><option value="">Visibilidade</option><option>Público</option><option>Logado</option><option>Plano específico</option></select>
        <div style={{ marginLeft:'auto',display:'flex',gap:6 }}>
          <span style={{ fontSize:12,color:'var(--text-muted)',alignSelf:'center' }}>{filtered.length} artigos</span>
          <button className="btn sm primary" onClick={()=>onNewArticle&&onNewArticle()}>
            <Icon name="plus" size={13}/>Novo artigo
          </button>
        </div>
      </div>
      <table className="data">
        <thead>
          <tr><th>Título</th><th>Categoria</th><th>Status</th><th>Visibilidade</th><th>Autor</th><th>Última revisão</th><th>Feedback</th><th>Views</th><th></th></tr>
        </thead>
        <tbody>
          {filtered.map(art=>{
            const sc = KB_STATUS_CFG_V2[art.status]||KB_STATUS_CFG_V2.rascunho;
            const total = art.feedback.pos + art.feedback.neg;
            const pct   = total > 0 ? Math.round(art.feedback.pos/total*100) : 0;
            return (
              <tr key={art.id} style={{ cursor:'pointer' }}
                onMouseEnter={e=>e.currentTarget.style.background='var(--bg-hover)'}
                onMouseLeave={e=>e.currentTarget.style.background=''}
              >
                <td>
                  <div style={{ display:'flex',alignItems:'center',gap:9 }}>
                    <div style={{ width:28,height:28,borderRadius:6,background:'var(--bg-subtle)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                      <Icon name="fileText" size={13} style={{ color:'var(--text-muted)' }}/>
                    </div>
                    <span style={{ fontWeight:500,fontSize:13,cursor:'pointer',color:'var(--text)' }} onClick={()=>onEditArticle&&onEditArticle(art)}>{art.title}</span>
                  </div>
                </td>
                <td><span className="badge neutral" style={{ fontSize:10 }}>{art.category}</span></td>
                <td><span className={`badge ${sc.cls}`} style={{ fontSize:10 }}><span className="dot"/>{sc.label}</span></td>
                <td style={{ fontSize:12,color:'var(--text-secondary)' }}>{art.visibility}</td>
                <td style={{ fontSize:12,color:'var(--text-secondary)' }}>{art.author}</td>
                <td style={{ fontSize:12,color:'var(--text-muted)' }}>{art.lastRevision}</td>
                <td>
                  {total>0 ? (
                    <div style={{ display:'flex',alignItems:'center',gap:6 }}>
                      <div style={{ width:40,height:4,borderRadius:2,background:'var(--bg-subtle)',overflow:'hidden' }}>
                        <div style={{ height:'100%',width:`${pct}%`,background:pct>=70?'var(--success)':pct>=40?'var(--warning)':'var(--danger)',borderRadius:2 }}/>
                      </div>
                      <span style={{ fontSize:11,color:'var(--text-muted)' }}>{pct}%</span>
                    </div>
                  ) : <span style={{ fontSize:11,color:'var(--text-muted)' }}>—</span>}
                </td>
                <td style={{ fontSize:12,color:'var(--text-secondary)',fontWeight:500 }}>{art.views.toLocaleString('pt-BR')}</td>
                <td>
                  <div className="row-actions">
                    <button className="icon-action" title="Editar" onClick={()=>onEditArticle&&onEditArticle(art)}><Icon name="edit" size={13}/></button>
                    <button className="icon-action" title="Ver público" onClick={()=>onToast&&onToast('Abrindo central pública…')}><Icon name="externalLink" size={13}/></button>
                  </div>
                </td>
              </tr>
            );
          })}
          {filtered.length===0&&(
            <tr><td colSpan={9} style={{ textAlign:'center',padding:'48px 20px',color:'var(--text-muted)' }}>
              <div style={{ marginBottom:8 }}><Icon name="fileText" size={28} style={{ opacity:.2 }}/></div>
              Nenhum artigo encontrado
            </td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

// ── Tab: Categorias ────────────────────────────────────────────────────────────
const KBCategoriesTab = ({ onToast, onNewCat, onAddCat }) => {
  const [cats, setCats] = React.useState([
    { name:'Configurações',  slug:'configuracoes',  articles:3, icon:'settings',    views:4200 },
    { name:'Pagamento',      slug:'pagamento',       articles:2, icon:'cardCoin',    views:3100 },
    { name:'Integrações',    slug:'integracoes',     articles:2, icon:'link',        views:1900 },
    { name:'E-mail',         slug:'email',           articles:1, icon:'mail',        views:640  },
    { name:'Marketing',      slug:'marketing',       articles:1, icon:'barChart',    views:480  },
    { name:'Billing',        slug:'billing',         articles:1, icon:'cardCoin',    views:3200 },
    { name:'Frete',          slug:'frete',           articles:1, icon:'package',     views:760  },
    { name:'Catálogo',       slug:'catalogo',        articles:1, icon:'layers',      views:480  },
  ]);

  // Expõe o setter via ref para o pai (SupportKBPage) poder injetar novas categorias
  React.useEffect(() => { if (onAddCat) onAddCat.current = (cat) => setCats(cs => [...cs, { name: cat.name, slug: cat.slug || cat.name.toLowerCase().replace(/\s+/g,'-'), articles: 0, views: 0, icon: cat.icon || 'layers' }]); }, []);

  return (
    <div>
      <div style={{ display:'flex',justifyContent:'flex-end',marginBottom:16 }}>
        <button className="btn primary sm" onClick={onNewCat}><Icon name="plus" size={13}/>Nova categoria</button>
      </div>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12 }}>
        {cats.map(c=>(
          <div key={c.name} className="card" style={{ overflow:'hidden',cursor:'pointer' }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow='var(--shadow-md)'}
            onMouseLeave={e=>e.currentTarget.style.boxShadow='var(--shadow-xs)'}
          >
            <div style={{ padding:'16px 18px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:12 }}>
                <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}>
                  <Icon name={c.icon} size={16} style={{ color:'var(--info)' }}/>
                </div>
                <div>
                  <div style={{ fontWeight:600,fontSize:13 }}>{c.name}</div>
                  <div style={{ fontSize:11,color:'var(--text-muted)' }}>/{c.slug}</div>
                </div>
                <button className="icon-action" style={{ marginLeft:'auto' }} onClick={()=>onToast&&onToast('Editando categoria…')}><Icon name="edit" size={13}/></button>
              </div>
              <div style={{ display:'flex',gap:12 }}>
                <div style={{ fontSize:12,color:'var(--text-secondary)' }}><strong style={{ color:'var(--text)' }}>{c.articles}</strong> artigos</div>
                <div style={{ fontSize:12,color:'var(--text-secondary)' }}><strong style={{ color:'var(--text)' }}>{c.views.toLocaleString('pt-BR')}</strong> views</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ── Tab: Buscas sem resultado ──────────────────────────────────────────────────
const KBSearchInsightsTab = ({ onToast, onNewArticle }) => {
  const searches = [
    { query:'como cancelar assinatura',    count:47, hasSolution:false },
    { query:'mudar senha de acesso',       count:38, hasSolution:false },
    { query:'exportar relatório csv',      count:29, hasSolution:false },
    { query:'configurar checkout customizado', count:24, hasSolution:false },
    { query:'api de produtos',             count:21, hasSolution:false },
    { query:'backup da loja',              count:18, hasSolution:false },
    { query:'cupom de desconto',           count:15, hasSolution:true  },
    { query:'app mobile',                  count:14, hasSolution:false },
  ];
  return (
    <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
      <div className="card" style={{ overflow:'hidden' }}>
        <div className="card-head"><Icon name="search" size={15} style={{ color:'var(--warning)' }}/><h3>Buscas sem resultado</h3><span className="sub">Últimos 30 dias</span></div>
        <table className="data">
          <thead><tr><th>Busca</th><th>Ocorrências</th><th>Artigo existente?</th><th></th></tr></thead>
          <tbody>
            {searches.map((s,i)=>(
              <tr key={i}>
                <td><span style={{ fontWeight:500,fontSize:13 }}>"{s.query}"</span></td>
                <td>
                  <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                    <div style={{ width:60,height:4,borderRadius:2,background:'var(--bg-subtle)',overflow:'hidden' }}>
                      <div style={{ height:'100%',width:`${s.count/47*100}%`,background:'var(--warning)',borderRadius:2 }}/>
                    </div>
                    <span style={{ fontSize:12,fontWeight:600 }}>{s.count}</span>
                  </div>
                </td>
                <td>{s.hasSolution ? <span className="badge success" style={{ fontSize:10 }}><span className="dot"/>Sim</span> : <span className="badge warning" style={{ fontSize:10 }}><span className="dot"/>Não</span>}</td>
                <td>
                  <div className="row-actions">
                    {!s.hasSolution && (
                      <button className="btn sm primary" onClick={()=>onNewArticle&&onNewArticle()}>
                        <Icon name="plus" size={12}/>Criar artigo
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ── Central Pública ────────────────────────────────────────────────────────────
const HelpCenterPreview = ({ onBack, onToast }) => {
  const [search, setSearch] = React.useState('');
  const [openArticle, setOpenArticle] = React.useState(null);
  const [openCategory, setOpenCategory] = React.useState(null);
  const [viewMode, setViewMode] = React.useState('admin');
  const [showTicketForm, setShowTicketForm] = React.useState(false);
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const [showMyTickets, setShowMyTickets] = React.useState(false);
  const [ticketConfirm, setTicketConfirm] = React.useState(null);
  const [catSearch, setCatSearch] = React.useState('');
  const [tForm, setTForm] = React.useState({name:'',email:'',loja:'',subject:'',category:'',description:'',priority:'media'});
  const [tSubmitted, setTSubmitted] = React.useState(false);
  const [loginEmail, setLoginEmail] = React.useState('');
  const [loginSenha, setLoginSenha] = React.useState('');

  const articles = KB_ARTICLES || [];
  const published = articles.filter(a=>a.status==='publicado');
  const cats = [...new Set(published.map(a=>a.category))];
  const catIcons = { 'Configurações':'settings','Pagamento':'cardCoin','Integrações':'link','E-mail':'mail','Billing':'cardCoin','Frete':'package','Catálogo':'layers','Marketing':'barChart' };
  const catDescs  = { 'Configurações':'Configurações gerais da loja, personalização e opções avançadas.','Pagamento':'Métodos de pagamento, checkout e integrações com gateways.','Integrações':'Marketplaces, ERPs, apps e ferramentas externas.','E-mail':'E-mails transacionais, templates e domínio de envio.','Billing':'Plano, faturas, cobranças e formas de pagamento.','Frete':'Regras de frete, transportadoras e zonas de entrega.','Catálogo':'Produtos, categorias, variações e importações em massa.','Marketing':'Campanhas, cupons, Google Merchant e integrações de marketing.' };
  const customer = { name:'Ana Pereira', email:'ana@lojaexemplo.com.br', initials:'AP' };
  const sCfg = { aberto:{l:'Aberto',c:'var(--info)'},aguardando_suporte:{l:'Ag. Suporte',c:'var(--warning)'},aguardando_cliente:{l:'Ag. Cliente',c:'var(--warning)'},resolvido:{l:'Resolvido',c:'var(--success)'} };
  const myTickets = [
    {id:'#4821',subject:'Checkout travado no mobile',status:'aberto',lastUpdate:'Há 15min'},
    {id:'#4817',subject:'Relatório de vendas com dados errados',status:'aguardando_suporte',lastUpdate:'Há 2h'},
    {id:'#4815',subject:'Integração Mercado Pago falhando',status:'resolvido',lastUpdate:'Há 4h'},
  ];

  React.useEffect(()=>{ setCatSearch(''); }, [openCategory]);
  React.useEffect(()=>{
    if (showTicketForm) {
      setTForm({name:viewMode==='customer'?customer.name:'',email:viewMode==='customer'?customer.email:'',loja:'',subject:'',category:'',description:'',priority:'media'});
      setTSubmitted(false);
    }
  }, [showTicketForm]);

  const tSet=(k,v)=>setTForm(f=>({...f,[k]:v}));
  const tRequired=['name','email','subject','description'];
  const tValid=tRequired.every(k=>tForm[k].trim());
  const tInputSt=(k)=>({width:'100%',height:34,padding:'0 10px',border:`1px solid ${tSubmitted&&!tForm[k]?.trim()?'var(--danger)':'var(--border-strong)'}`,borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit'});
  const handleTicketSubmit=()=>{
    setTSubmitted(true);
    if (!tValid) return;
    const id='#'+(5000+Math.floor(Math.random()*900));
    setTicketConfirm({id,subject:tForm.subject});
    setShowTicketForm(false);
  };

  // ── TopBar JSX (re-evaluated each render) ────────────────────────────────
  const TopBar = (
    <div style={{background:'var(--brand-navy)',padding:'14px 24px',display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
      <img src="assets/tezus-logo.svg" alt="Tezus" style={{height:22,filter:'brightness(0) invert(1)',opacity:.9}}/>
      <span style={{color:'rgba(255,255,255,0.5)',fontSize:13}}> / </span>
      <span style={{color:'rgba(255,255,255,0.8)',fontSize:13}}>
        {openCategory ? <><span style={{cursor:'pointer',opacity:.7,textDecoration:'underline'}} onClick={()=>setOpenCategory(null)}>Central de Ajuda</span>{' / '}{openCategory}</> :
         openArticle  ? <><span style={{cursor:'pointer',opacity:.7,textDecoration:'underline'}} onClick={()=>setOpenArticle(null)}>Central de Ajuda</span>{' / '}{openArticle.category}</> :
         showMyTickets? <><span style={{cursor:'pointer',opacity:.7,textDecoration:'underline'}} onClick={()=>setShowMyTickets(false)}>Central de Ajuda</span>{' / Meus tickets'}</> :
         'Central de Ajuda'}
      </span>
      {onBack && (
        <div style={{display:'flex',gap:3,background:'rgba(255,255,255,0.1)',borderRadius:8,padding:3,marginLeft:12}}>
          {[{id:'admin',l:'Admin'},{id:'visitor',l:'Visitante'},{id:'customer',l:'Cliente'}].map(m=>(
            <button key={m.id} onClick={()=>setViewMode(m.id)} style={{padding:'3px 10px',borderRadius:5,border:'none',fontSize:11,fontWeight:600,cursor:'pointer',background:viewMode===m.id?'rgba(255,255,255,0.25)':'transparent',color:'rgba(255,255,255,0.9)',transition:'all 120ms'}}>{m.l}</button>
          ))}
        </div>
      )}
      <div style={{marginLeft:'auto',display:'flex',gap:8,alignItems:'center'}}>
        {viewMode==='admin' && <>
          <span style={{background:'rgba(255,255,255,0.12)',color:'rgba(255,255,255,0.7)',fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:4,letterSpacing:'0.05em',textTransform:'uppercase',whiteSpace:'nowrap'}}>Prévia da central</span>
          {onBack && <button className="btn sm" style={{background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'white',fontSize:12}} onClick={onBack}>← Voltar ao admin</button>}
        </>}
        {viewMode==='visitor' && <>
          <button className="btn sm" style={{background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'white',fontSize:12}} onClick={()=>setShowLoginModal(true)}>Entrar</button>
          <button className="btn sm primary" style={{fontSize:12}} onClick={()=>setShowTicketForm(true)}><Icon name="plus" size={12}/>Abrir ticket</button>
        </>}
        {viewMode==='customer' && <>
          <button className="btn sm" style={{background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'white',fontSize:12}} onClick={()=>setShowMyTickets(true)}><Icon name="messageCircle" size={12}/>Meus tickets</button>
          <button className="btn sm primary" style={{fontSize:12}} onClick={()=>setShowTicketForm(true)}><Icon name="plus" size={12}/>Abrir ticket</button>
          <div style={{width:30,height:30,borderRadius:'50%',background:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'white',cursor:'pointer',flexShrink:0}} title={customer.name}>{customer.initials}</div>
        </>}
      </div>
    </div>
  );

  // ── Overlay JSX variables ─────────────────────────────────────────────────
  const TicketFormOverlay = showTicketForm && (
    <div onClick={()=>setShowTicketForm(false)} style={{position:'fixed',inset:0,background:'rgba(10,22,40,0.5)',backdropFilter:'blur(3px)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{width:560,maxHeight:'90vh',background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',display:'flex',flexDirection:'column'}}>
        <div style={{padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12}}>
          <div style={{width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center'}}><Icon name="messageCircle" size={16} style={{color:'var(--info)'}}/></div>
          <div><div style={{fontWeight:600,fontSize:15}}>Abrir ticket de suporte</div><div style={{fontSize:12,color:'var(--text-muted)'}}>Nossa equipe responde em até 24h úteis</div></div>
          <button className="icon-action" style={{marginLeft:'auto'}} onClick={()=>setShowTicketForm(false)}><Icon name="x" size={15}/></button>
        </div>
        <div style={{flex:1,overflowY:'auto',padding:'20px 22px'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div>
              <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Nome <span style={{color:'var(--danger)'}}>*</span></label>
              <input style={tInputSt('name')} value={tForm.name} onChange={e=>tSet('name',e.target.value)} placeholder="Seu nome"/>
              {tSubmitted&&!tForm.name&&<div style={{fontSize:11,color:'var(--danger)',marginTop:3}}>Obrigatório</div>}
            </div>
            <div>
              <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>E-mail <span style={{color:'var(--danger)'}}>*</span></label>
              <input style={tInputSt('email')} type="email" value={tForm.email} onChange={e=>tSet('email',e.target.value)} placeholder="seu@email.com"/>
              {tSubmitted&&!tForm.email&&<div style={{fontSize:11,color:'var(--danger)',marginTop:3}}>Obrigatório</div>}
            </div>
          </div>
          <div style={{marginBottom:14}}>
            <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Loja (opcional)</label>
            <input style={{width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit'}} value={tForm.loja} onChange={e=>tSet('loja',e.target.value)} placeholder="Nome da sua loja"/>
          </div>
          <div style={{marginBottom:14}}>
            <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Assunto <span style={{color:'var(--danger)'}}>*</span></label>
            <input style={tInputSt('subject')} value={tForm.subject} onChange={e=>tSet('subject',e.target.value)} placeholder="Descreva o problema brevemente"/>
            {tSubmitted&&!tForm.subject&&<div style={{fontSize:11,color:'var(--danger)',marginTop:3}}>Obrigatório</div>}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div>
              <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Categoria</label>
              <select className="select" style={{width:'100%',height:34}} value={tForm.category} onChange={e=>tSet('category',e.target.value)}>
                <option value="">Selecionar…</option>
                {['Configurações','Pagamento','Integrações','E-mail','Billing','Frete','Catálogo','Outro'].map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Prioridade</label>
              <select className="select" style={{width:'100%',height:34}} value={tForm.priority} onChange={e=>tSet('priority',e.target.value)}>
                <option value="baixa">Baixa</option><option value="media">Média</option><option value="alta">Alta</option>
              </select>
            </div>
          </div>
          <div style={{marginBottom:14}}>
            <label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Descrição <span style={{color:'var(--danger)'}}>*</span></label>
            <textarea value={tForm.description} onChange={e=>tSet('description',e.target.value)} placeholder="Descreva o problema com detalhes…" style={{width:'100%',minHeight:100,padding:'10px',border:`1px solid ${tSubmitted&&!tForm.description?'var(--danger)':'var(--border-strong)'}`,borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit',resize:'vertical',lineHeight:1.5}}/>
            {tSubmitted&&!tForm.description&&<div style={{fontSize:11,color:'var(--danger)',marginTop:3}}>Obrigatório</div>}
          </div>
          <button className="btn sm ghost" style={{borderStyle:'dashed'}} onClick={()=>onToast('Selecionar arquivo…')}><Icon name="paperclip" size={13}/>Anexar arquivo</button>
        </div>
        <div style={{padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end'}}>
          <button className="btn ghost" onClick={()=>setShowTicketForm(false)}>Cancelar</button>
          <button className="btn primary" onClick={handleTicketSubmit}><Icon name="send" size={13}/>Enviar ticket</button>
        </div>
      </div>
    </div>
  );

  const LoginOverlay = showLoginModal && (
    <div onClick={()=>setShowLoginModal(false)} style={{position:'fixed',inset:0,background:'rgba(10,22,40,0.5)',backdropFilter:'blur(3px)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{width:400,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',overflow:'hidden'}}>
        <div style={{padding:'32px 28px 16px',textAlign:'center'}}>
          <img src="assets/tezus-logo.svg" alt="Tezus" style={{height:26,marginBottom:20}}/>
          <div style={{fontWeight:700,fontSize:18,marginBottom:6}}>Entrar na Central de Ajuda</div>
          <div style={{fontSize:13,color:'var(--text-muted)',marginBottom:20}}>Use o mesmo e-mail do painel da sua loja</div>
          <div style={{display:'flex',flexDirection:'column',gap:12,textAlign:'left'}}>
            <div><label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>E-mail</label><input type="email" value={loginEmail} onChange={e=>setLoginEmail(e.target.value)} placeholder="ana@lojaexemplo.com.br" style={{width:'100%',height:38,padding:'0 12px',border:'1px solid var(--border-strong)',borderRadius:8,background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit'}}/></div>
            <div><label style={{display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5}}>Senha</label><input type="password" value={loginSenha} onChange={e=>setLoginSenha(e.target.value)} placeholder="••••••••" style={{width:'100%',height:38,padding:'0 12px',border:'1px solid var(--border-strong)',borderRadius:8,background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit'}}/></div>
            <a href="#" style={{fontSize:12,color:'var(--primary)',textAlign:'right',textDecoration:'none'}} onClick={e=>{e.preventDefault();onToast('Link de redefinição enviado por e-mail')}}>Esqueci minha senha</a>
          </div>
        </div>
        <div style={{padding:'8px 28px 24px',display:'flex',gap:10}}>
          <button className="btn ghost" style={{flex:1,justifyContent:'center'}} onClick={()=>setShowLoginModal(false)}>Cancelar</button>
          <button className="btn primary" style={{flex:1,justifyContent:'center'}} onClick={()=>{setShowLoginModal(false);setViewMode('customer');onToast('Bem-vinda, Ana! ✓');}}>Entrar</button>
        </div>
      </div>
    </div>
  );

  const TicketConfirmOverlay = ticketConfirm && (
    <div onClick={()=>setTicketConfirm(null)} style={{position:'fixed',inset:0,background:'rgba(10,22,40,0.5)',backdropFilter:'blur(3px)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{width:420,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',overflow:'hidden',textAlign:'center'}}>
        <div style={{padding:'36px 28px 20px'}}>
          <div style={{width:56,height:56,borderRadius:'50%',background:'var(--success-bg)',margin:'0 auto 20px',display:'flex',alignItems:'center',justifyContent:'center'}}><Icon name="check" size={26} style={{color:'var(--success)'}}/></div>
          <div style={{fontWeight:700,fontSize:18,marginBottom:8}}>Ticket criado com sucesso!</div>
          <div style={{fontWeight:600,fontSize:24,color:'var(--brand-navy)',letterSpacing:'-0.01em',marginBottom:8}}>{ticketConfirm.id}</div>
          <div style={{fontSize:13,color:'var(--text-secondary)',lineHeight:1.6,marginBottom:6}}>{ticketConfirm.subject}</div>
          <div style={{fontSize:12,color:'var(--text-muted)'}}>Responderemos em até 24h úteis.</div>
        </div>
        <div style={{padding:'12px 28px 24px',display:'flex',gap:10,justifyContent:'center'}}>
          <button className="btn ghost" onClick={()=>setTicketConfirm(null)}>← Voltar para Central</button>
          {viewMode==='customer'&&<button className="btn primary" onClick={()=>{setTicketConfirm(null);setShowMyTickets(true);}}>Ver meus tickets</button>}
        </div>
      </div>
    </div>
  );

  // ── My Tickets Page ───────────────────────────────────────────────────────
  if (showMyTickets) return (
    <div style={{background:'var(--bg)',minHeight:'100vh',display:'flex',flexDirection:'column'}}>
      {TopBar}
      <div style={{maxWidth:700,margin:'0 auto',padding:'40px 24px',width:'100%',flex:1}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
          <div><h1 style={{fontSize:24,fontWeight:700,marginBottom:4}}>Meus tickets</h1><div style={{fontSize:13,color:'var(--text-muted)'}}>Olá, {customer.name} · {customer.email}</div></div>
          <button className="btn primary" onClick={()=>setShowTicketForm(true)}><Icon name="plus" size={13}/>Novo ticket</button>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {myTickets.map(t=>{
            const sc=sCfg[t.status]||sCfg.aberto;
            return (
              <div key={t.id} className="card" style={{padding:'16px 20px',display:'flex',alignItems:'center',gap:14}}>
                <div style={{width:36,height:36,borderRadius:8,background:'var(--bg-subtle)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Icon name="messageCircle" size={16} style={{color:'var(--text-muted)'}}/></div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:600,fontSize:14,marginBottom:3}}>{t.subject}</div>
                  <div style={{display:'flex',gap:8,alignItems:'center'}}>
                    <span style={{fontFamily:'JetBrains Mono,monospace',fontSize:11,color:'var(--text-muted)'}}>{t.id}</span>
                    <span style={{fontSize:11,color:'var(--text-muted)'}}>· Atualizado {t.lastUpdate}</span>
                  </div>
                </div>
                <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:'3px 10px',borderRadius:20,background:sc.c+'18',color:sc.c,fontSize:11,fontWeight:700,flexShrink:0,whiteSpace:'nowrap'}}>
                  <span style={{width:5,height:5,borderRadius:'50%',background:sc.c}}/>{sc.l}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      {TicketFormOverlay}{TicketConfirmOverlay}
    </div>
  );

  // ── Category Page ─────────────────────────────────────────────────────────
  if (openCategory) {
    const catArts = published.filter(a=>a.category===openCategory);
    const filtered = catSearch ? catArts.filter(a=>a.title.toLowerCase().includes(catSearch.toLowerCase())) : catArts;
    return (
      <div style={{background:'var(--bg)',minHeight:'100vh',display:'flex',flexDirection:'column'}}>
        {TopBar}
        <div style={{maxWidth:800,margin:'0 auto',padding:'40px 24px',width:'100%',flex:1}}>
          <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:20,display:'flex',alignItems:'center',gap:6}}>
            <span style={{cursor:'pointer',color:'var(--primary)'}} onClick={()=>setOpenCategory(null)}>Central de ajuda</span>
            <Icon name="chevronRight" size={11}/>
            <span style={{color:'var(--text)'}}>{openCategory}</span>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:14,marginBottom:24}}>
            <div style={{width:48,height:48,borderRadius:12,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Icon name={catIcons[openCategory]||'fileText'} size={22} style={{color:'var(--info)'}}/></div>
            <div><h1 style={{fontSize:24,fontWeight:700,marginBottom:4}}>{openCategory}</h1><div style={{fontSize:13,color:'var(--text-muted)'}}>{catDescs[openCategory]||'Artigos sobre '+openCategory} · {catArts.length} artigos</div></div>
          </div>
          <div style={{position:'relative',marginBottom:24}}>
            <Icon name="search" size={15} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',pointerEvents:'none'}}/>
            <input value={catSearch} onChange={e=>setCatSearch(e.target.value)} placeholder={`Buscar em ${openCategory}…`} style={{width:'100%',height:44,paddingLeft:42,paddingRight:16,border:'1px solid var(--border)',borderRadius:10,fontSize:14,fontFamily:'inherit',color:'var(--text)',background:'var(--bg-elevated)'}}/>
          </div>
          {filtered.length===0 ? (
            <div style={{textAlign:'center',padding:'40px 20px',color:'var(--text-muted)'}}><Icon name="search" size={28} style={{opacity:.2,display:'block',margin:'0 auto 10px'}}/>Nenhum artigo encontrado para "{catSearch}"</div>
          ) : (
            <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:32}}>
              {filtered.map(art=>(
                <div key={art.id} className="card" style={{padding:'16px 20px',display:'flex',alignItems:'center',gap:14,cursor:'pointer'}}
                  onClick={()=>{setOpenArticle(art);setOpenCategory(null);}}
                  onMouseEnter={e=>e.currentTarget.style.boxShadow='var(--shadow-md)'}
                  onMouseLeave={e=>e.currentTarget.style.boxShadow='var(--shadow-xs)'}
                >
                  <div style={{width:34,height:34,borderRadius:8,background:'var(--bg-subtle)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Icon name="fileText" size={15} style={{color:'var(--text-muted)'}}/></div>
                  <div style={{flex:1}}><div style={{fontWeight:500,fontSize:14}}>{art.title}</div><div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>{art.views.toLocaleString('pt-BR')} views · {art.lastRevision}</div></div>
                  <Icon name="arrowRight" size={15} style={{color:'var(--text-muted)',flexShrink:0}}/>
                </div>
              ))}
            </div>
          )}
          <div style={{background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:12,padding:'20px 24px',textAlign:'center'}}>
            <div style={{fontWeight:600,fontSize:15,marginBottom:6}}>Não encontrou o que precisava?</div>
            <div style={{fontSize:13,color:'var(--text-muted)',marginBottom:14}}>Nossa equipe está disponível para ajudar.</div>
            <div style={{display:'flex',justifyContent:'center',gap:10}}>
              <button className="btn ghost" onClick={()=>setOpenCategory(null)}>← Voltar para Central</button>
              <button className="btn primary" onClick={()=>setShowTicketForm(true)}><Icon name="messageCircle" size={13}/>Abrir ticket</button>
            </div>
          </div>
        </div>
        {TicketFormOverlay}{TicketConfirmOverlay}
      </div>
    );
  }

  // ── Article Page ──────────────────────────────────────────────────────────
  if (openArticle) {
    return (
      <div style={{ background:'var(--bg)',minHeight:'100vh',display:'flex',flexDirection:'column' }}>
        {TopBar}
        <div style={{ maxWidth:760,margin:'0 auto',padding:'40px 24px',flex:1 }}>
          <div style={{ fontSize:12,color:'var(--text-muted)',marginBottom:16 }}>
            <span style={{ cursor:'pointer',color:'var(--primary)' }} onClick={()=>setOpenArticle(null)}>Central de ajuda</span>
            {' / '}<span style={{ cursor:'pointer',color:'var(--primary)' }} onClick={()=>{setOpenCategory(openArticle.category);setOpenArticle(null);}}>{openArticle.category}</span>
            {' / '}<span style={{ color:'var(--text)' }}>{openArticle.title}</span>
          </div>
          <h1 style={{ fontSize:28,fontWeight:700,marginBottom:8 }}>{openArticle.title}</h1>
          <div style={{ display:'flex',alignItems:'center',gap:12,marginBottom:28,color:'var(--text-muted)',fontSize:13 }}>
            <span>Por {openArticle.author}</span>
            <span>·</span>
            <span>Última revisão: {openArticle.lastRevision}</span>
            <span style={{ marginLeft:'auto',display:'flex',alignItems:'center',gap:4 }}><Icon name="bookOpen" size={13}/>{openArticle.views.toLocaleString('pt-BR')} views</span>
          </div>
          <div style={{ fontSize:15,lineHeight:1.8,color:'var(--text-secondary)',marginBottom:40 }}>
            <p>Este artigo explica passo a passo como configurar <strong>{openArticle.title.toLowerCase()}</strong> na sua loja Tezus.</p>
            <h2 style={{ fontSize:18,fontWeight:600,color:'var(--text)',margin:'24px 0 12px' }}>Pré-requisitos</h2>
            <ul style={{ paddingLeft:20,marginBottom:16 }}><li>Acesso ao painel administrativo</li><li>Permissões de configuração ativas</li></ul>
            <h2 style={{ fontSize:18,fontWeight:600,color:'var(--text)',margin:'24px 0 12px' }}>Passo a passo</h2>
            <ol style={{ paddingLeft:20,display:'flex',flexDirection:'column',gap:8 }}>
              <li>Acesse <strong>Configurações</strong> no menu lateral da sua loja</li>
              <li>Localize a seção <strong>{openArticle.category}</strong></li>
              <li>Preencha os campos necessários conforme solicitado</li>
              <li>Clique em <strong>Salvar</strong> para confirmar as alterações</li>
            </ol>
          </div>
          {/* Feedback */}
          <div style={{ borderTop:'1px solid var(--border)',paddingTop:28 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:15,fontWeight:600,marginBottom:14 }}>Este artigo foi útil?</div>
              <div style={{ display:'flex',justifyContent:'center',gap:12 }}>
                <button className="btn" style={{ gap:8 }} onClick={()=>onToast&&onToast('Obrigado pelo feedback!')}><Icon name="thumbsUp" size={14}/>Sim, ajudou</button>
                <button className="btn" style={{ gap:8 }} onClick={()=>onToast&&onToast('Feedback registrado!')}><Icon name="thumbsDown" size={14}/>Não ajudou</button>
              </div>
            </div>
            <div style={{ textAlign:'center',marginTop:24,padding:'20px',background:'var(--bg-subtle)',borderRadius:12 }}>
              <div style={{ fontWeight:600,marginBottom:6 }}>Ainda com dúvidas?</div>
              <p style={{ fontSize:13,color:'var(--text-muted)',marginBottom:12 }}>Nossa equipe está pronta para ajudar.</p>
              <button className="btn primary" onClick={()=>setShowTicketForm(true)}>
                <Icon name="messageCircle" size={14}/>Abrir ticket de suporte
              </button>
            </div>
          </div>
        </div>
        {TicketFormOverlay}{TicketConfirmOverlay}
      </div>
    );
  }

  // ── Home ──────────────────────────────────────────────────────────────────
  return (
    <div style={{ background:'var(--bg)',minHeight:'100vh',display:'flex',flexDirection:'column' }}>
      {TopBar}
      {/* Hero */}
      <div style={{ background:'var(--brand-navy)',padding:'48px 24px 64px',textAlign:'center' }}>
        <h1 style={{ color:'white',fontSize:30,fontWeight:700,marginBottom:8 }}>Como podemos ajudar?</h1>
        <p style={{ color:'rgba(255,255,255,0.6)',marginBottom:24,fontSize:15 }}>Encontre respostas rápidas para as dúvidas mais comuns</p>
        <div style={{ maxWidth:520,margin:'0 auto',position:'relative' }}>
          <Icon name="search" size={16} style={{ position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)' }}/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar artigos, guias e tutoriais…" style={{ width:'100%',height:46,padding:'0 16px 0 42px',border:'none',borderRadius:10,fontSize:15,fontFamily:'inherit',color:'var(--text)',boxShadow:'var(--shadow-lg)' }}/>
        </div>
      </div>

      <div style={{ maxWidth:900,margin:'-24px auto 0',padding:'0 24px 48px',flex:1,width:'100%' }}>
        {/* Categorias */}
        <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:36 }}>
          {cats.map(cat=>(
            <div key={cat} className="card" style={{ padding:'18px 16px',textAlign:'center',cursor:'pointer',transition:'box-shadow 160ms' }}
              onClick={()=>setOpenCategory(cat)}
              onMouseEnter={e=>e.currentTarget.style.boxShadow='var(--shadow-md)'}
              onMouseLeave={e=>e.currentTarget.style.boxShadow='var(--shadow-xs)'}
            >
              <div style={{ width:44,height:44,borderRadius:10,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 10px' }}>
                <Icon name={catIcons[cat]||'fileText'} size={20} style={{ color:'var(--info)' }}/>
              </div>
              <div style={{ fontWeight:600,fontSize:13 }}>{cat}</div>
              <div style={{ fontSize:11,color:'var(--text-muted)',marginTop:2 }}>
                {published.filter(a=>a.category===cat).length} artigos
              </div>
            </div>
          ))}
        </div>

        {/* Artigos populares */}
        <div style={{ marginBottom:36 }}>
          <h2 style={{ fontSize:17,fontWeight:600,marginBottom:14 }}>Artigos mais acessados</h2>
          <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
            {[...published].sort((a,b)=>b.views-a.views).slice(0,5).map(art=>(
              <div key={art.id} className="card" style={{ padding:'14px 18px',display:'flex',alignItems:'center',gap:14,cursor:'pointer' }}
                onClick={()=>setOpenArticle(art)}
                onMouseEnter={e=>e.currentTarget.style.boxShadow='var(--shadow-md)'}
                onMouseLeave={e=>e.currentTarget.style.boxShadow='var(--shadow-xs)'}
              >
                <div style={{ width:34,height:34,borderRadius:8,background:'var(--bg-subtle)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                  <Icon name="fileText" size={15} style={{ color:'var(--text-muted)' }}/>
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:500,fontSize:14 }}>{art.title}</div>
                  <div style={{ fontSize:11,color:'var(--text-muted)',marginTop:2 }}>{art.category} · {art.views.toLocaleString('pt-BR')} views</div>
                </div>
                <Icon name="arrowRight" size={15} style={{ color:'var(--text-muted)',flexShrink:0 }}/>
              </div>
            ))}
          </div>
        </div>

        {/* CTA suporte */}
        <div style={{ background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:12,padding:'24px',textAlign:'center' }}>
          <div style={{ fontWeight:600,fontSize:15,marginBottom:6 }}>Não encontrou o que precisava?</div>
          <p style={{ fontSize:13,color:'var(--text-muted)',marginBottom:16 }}>Nosso suporte está disponível para ajudar com qualquer dúvida.</p>
          <button className="btn primary" onClick={()=>setShowTicketForm(true)}>
            <Icon name="messageCircle" size={14}/>Abrir ticket de suporte
          </button>
        </div>
      </div>
      {TicketFormOverlay}{LoginOverlay}{TicketConfirmOverlay}
    </div>
  );
};

// ── Página principal: Base de Conhecimento ─────────────────────────────────────
const SupportKBPage = ({ onToast, onNav, articleContext }) => {
  const [tab, setTab]           = React.useState('articles');
  const [subPage, setSubPage]   = React.useState(() =>
    articleContext ? { type: 'article-editor', article: null, ticketContext: articleContext } : null
  );
  const [showCatModal, setShowCatModal] = React.useState(false);
  const addCatRef = React.useRef(null);

  // Estado local dos artigos — fonte única para lista + editor
  const [articles, setArticles] = React.useState(KB_ARTICLES || []);

  // Detecta mudança em articleContext (ex: ticket abre editor de novo)
  React.useEffect(() => {
    if (articleContext) setSubPage({ type: 'article-editor', article: null, ticketContext: articleContext });
  }, [articleContext]);

  const handleSaveArticle = (savedArticle) => {
    setArticles(arts => {
      const idx = arts.findIndex(a => a.id === savedArticle.id);
      if (idx >= 0) {
        const updated = [...arts];
        updated[idx] = { ...arts[idx], ...savedArticle };
        return updated;
      }
      return [savedArticle, ...arts];
    });
    // Sincronizar KB_ARTICLES para outros consumidores
    setKB_ARTICLES((KB_ARTICLES || []).map(a => a.id === savedArticle.id ? { ...a, ...savedArticle } : a));
    if (!(KB_ARTICLES || []).find(a => a.id === savedArticle.id)) {
      setKB_ARTICLES([savedArticle, ...(KB_ARTICLES || [])]);
    }
    // Back-link Ticket → Artigo
    if (savedArticle.sourceTicket) {
      TICKET_ARTICLES = TICKET_ARTICLES || {};
      const existing = TICKET_ARTICLES[savedArticle.sourceTicket] || [];
      const artRef = { id: savedArticle.id, title: savedArticle.title || 'Sem título', status: savedArticle.status, category: savedArticle.category };
      const refIdx = existing.findIndex(a => a.id === artRef.id);
      TICKET_ARTICLES[savedArticle.sourceTicket] = refIdx >= 0
        ? existing.map(a => a.id === artRef.id ? artRef : a)
        : [...existing, artRef];
      if (runtimeHooks.notifyTicketArticle) runtimeHooks.notifyTicketArticle(savedArticle.sourceTicket, artRef);
    }
  };

  const kbKpis = [
    { label:'Publicados',           value: articles.filter(a=>a.status==='publicado').length,       icon:'fileText',   ok:true    },
    { label:'Rascunhos',            value: articles.filter(a=>a.status==='rascunho').length,        icon:'edit'                   },
    { label:'Precisam revisão',     value: articles.filter(a=>a.status==='precisa_revisao').length, icon:'alert',      warn:true  },
    { label:'Buscas s/ resultado',  value: 47,                                                       icon:'search',     warn:true  },
    { label:'Tickets evitados',     value: articles.reduce((s,a)=>s+(a.ticketsAvoided||0),0),       icon:'check',      ok:true    },
    { label:'Feedback negativo',    value: articles.reduce((s,a)=>s+(a.feedback?.neg||0),0),        icon:'thumbsDown', danger:true },
  ];

  const TABS = [
    { id:'articles',  label:'Artigos',              icon:'fileText'  },
    { id:'categories',label:'Categorias',           icon:'layers'    },
    { id:'searches',  label:'Buscas sem resultado', icon:'search'    },
    { id:'feedback',  label:'Feedback',             icon:'thumbsUp'  },
  ];

  if (subPage?.type === 'article-editor') {
    return (
      <div className="content wide" style={{ maxWidth:1200 }}>
        <KBArticleEditorV2
          article={subPage.article}
          ticketContext={subPage.ticketContext || null}
          onBack={()=>setSubPage(null)}
          onToast={onToast}
          onSave={handleSaveArticle}
          onNav={onNav}
        />
      </div>
    );
  }
  if (subPage?.type === 'help-center') {
    return <HelpCenterPreview onBack={()=>setSubPage(null)} onToast={onToast}/>;
  }

  return (
    <div className="content wide" style={{ maxWidth:1300 }}>
      <NovaCategoriaModal open={showCatModal} onClose={()=>setShowCatModal(false)} onToast={onToast} onAdd={(cat)=>{ if (addCatRef.current) addCatRef.current(cat); }}/>

      <div className="page-header">
        <div>
          <h1>Base de Conhecimento</h1>
          <p className="sub">Artigos públicos, guias e respostas para reduzir tickets repetidos.</p>
          <div style={{ fontSize:11,fontFamily:'JetBrains Mono,monospace',color:'var(--text-muted)',opacity:.6,marginTop:3 }}>/admin/support/knowledge-base</div>
        </div>
        <div className="actions">
          <button className="btn" onClick={()=>setShowCatModal(true)}><Icon name="plus" size={14}/>Nova categoria</button>
          <button className="btn" onClick={()=>setSubPage({ type:'help-center' })}><Icon name="externalLink" size={14}/>Ver central pública</button>
          <button className="btn primary" onClick={()=>setSubPage({ type:'article-editor', article:null })}><Icon name="plus" size={14}/>Novo artigo</button>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:12,marginBottom:20 }}>
        {kbKpis.map(k=>(
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
            <div className="value" style={{ fontSize:22,color:k.danger?'var(--danger)':k.warn?'var(--warning)':k.ok?'var(--success)':undefined }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex',borderBottom:'1px solid var(--border)',marginBottom:24 }}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            display:'flex',alignItems:'center',gap:6,padding:'9px 14px',border:'none',background:'transparent',
            fontSize:13,fontWeight:tab===t.id?600:500,color:tab===t.id?'var(--text)':'var(--text-muted)',
            borderBottom:tab===t.id?'2px solid var(--brand-navy)':'2px solid transparent',
            marginBottom:-1,cursor:'pointer',transition:'color 120ms',whiteSpace:'nowrap',
          }}>
            <Icon name={t.icon} size={13}/>{t.label}
          </button>
        ))}
      </div>

      {tab==='articles'   && <KBArticlesTab articles={articles} onEditArticle={a=>setSubPage({type:'article-editor',article:a})} onNewArticle={()=>setSubPage({type:'article-editor',article:null})} onToast={onToast}/>}
      {tab==='categories' && <KBCategoriesTab onToast={onToast} onNewCat={()=>setShowCatModal(true)} onAddCat={addCatRef}/>}
      {tab==='searches'   && <KBSearchInsightsTab onToast={onToast} onNewArticle={()=>setSubPage({type:'article-editor',article:null})}/>}
      {tab==='feedback'   && (
        <div className="card" style={{ overflow:'hidden' }}>
          <div className="card-head"><Icon name="thumbsDown" size={14} style={{ color:'var(--warning)' }}/><h3>Artigos com feedback negativo</h3></div>
          <table className="data">
            <thead><tr><th>Artigo</th><th>Categoria</th><th>👍 Positivo</th><th>👎 Negativo</th><th>Taxa positiva</th><th></th></tr></thead>
            <tbody>
              {(KB_ARTICLES||[]).filter(a=>a.feedback.neg>0).sort((a,b)=>b.feedback.neg-a.feedback.neg).map(a=>{
                const total = a.feedback.pos+a.feedback.neg;
                const pct = Math.round(a.feedback.pos/total*100);
                return (
                  <tr key={a.id}>
                    <td><span style={{ fontWeight:500,fontSize:13 }}>{a.title}</span></td>
                    <td><span className="badge neutral" style={{ fontSize:10 }}>{a.category}</span></td>
                    <td style={{ color:'var(--success)',fontWeight:600,fontSize:13 }}>{a.feedback.pos}</td>
                    <td style={{ color:'var(--danger)',fontWeight:600,fontSize:13 }}>{a.feedback.neg}</td>
                    <td>
                      <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                        <div style={{ width:60,height:4,borderRadius:2,background:'var(--bg-subtle)',overflow:'hidden' }}>
                          <div style={{ height:'100%',width:`${pct}%`,background:pct>=70?'var(--success)':'var(--warning)',borderRadius:2 }}/>
                        </div>
                        <span style={{ fontSize:11,fontWeight:600 }}>{pct}%</span>
                      </div>
                    </td>
                    <td><div className="row-actions"><button className="btn sm" onClick={()=>onToast&&onToast('Revisando artigo…')}><Icon name="edit" size={12}/>Revisar</button></div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export {
  HelpCenterPreview,
  KBArticleEditorV2,
  NovaCategoriaModal,
  SupportKBPage,
};
